<template>
  <div :class="$style.box">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
}
</style>